// Section 5 and 14: Restless. Emigration threshold lower (pressure 1.25x); happiness decays
// faster when idle (idle term 1.5x). Constants: config.traits.restless.
import type { Config } from '../../config';
import { mod } from '../../core/modifiers';
import { neverRestricts, targetPerson } from '../../core/content-helpers';
import { isRetired } from '../../core/queries';
import { defineTrait } from '../../core/registry';

export function restless(config: Config) {
  const c = config.traits.restless;

  return defineTrait({
    id: 'restless',
    label: 'Restless',
    section: 'S5',
    modifierTargets: ['emigrationPressure', 'happinessTarget'],
    modifiers(ctx, target) {
      const p = targetPerson(ctx, target);
      if (p?.traits.includes('restless') !== true) return [];
      if (target.kind === 'emigrationPressure')
        return [mod.mul('trait:restless', c.emigrationPressureMul, 'restless')];
      const idle =
        p.job === 'rest' &&
        !isRetired(ctx.state, p, ctx.cfg) &&
        p.streaks.idle >= ctx.cfg.jobs.rest.idleSeasonsBeforePenalty;
      if (target.kind === 'happinessTarget' && idle) {
        return [
          mod.add(
            'trait:restless',
            ctx.cfg.happiness.idle * (c.idleHappinessMul - 1),
            'restless when idle',
          ),
        ];
      }
      return [];
    },
    restricts: neverRestricts,
  });
}
